const countries = [
  { code: "AF", name: "Afghanistan", dial: "+93", flag: "\ud83c\udde6\ud83c\uddeb" },
  { code: "AL", name: "Albania", dial: "+355", flag: "\ud83c\udde6\ud83c\uddf1" },
  { code: "DZ", name: "Algeria", dial: "+213", flag: "\ud83c\udde9\ud83c\uddff" },
  { code: "AD", name: "Andorra", dial: "+376", flag: "\ud83c\udde6\ud83c\udde9" },
  { code: "AO", name: "Angola", dial: "+244", flag: "\ud83c\udde6\ud83c\uddf4" },
  { code: "AR", name: "Argentina", dial: "+54", flag: "\ud83c\udde6\ud83c\uddf7" },
  { code: "AM", name: "Armenia", dial: "+374", flag: "\ud83c\udde6\ud83c\uddf2" },
  { code: "AU", name: "Australia", dial: "+61", flag: "\ud83c\udde6\ud83c\uddfa" },
  { code: "AT", name: "Austria", dial: "+43", flag: "\ud83c\udde6\ud83c\uddf9" },
  { code: "AZ", name: "Azerbaijan", dial: "+994", flag: "\ud83c\udde6\ud83c\uddff" },
  { code: "BH", name: "Bahrain", dial: "+973", flag: "\ud83c\udde7\ud83c\udded" },
  { code: "BD", name: "Bangladesh", dial: "+880", flag: "\ud83c\udde7\ud83c\udde9" },
  { code: "BY", name: "Belarus", dial: "+375", flag: "\ud83c\udde7\ud83c\uddfe" },
  { code: "BE", name: "Belgium", dial: "+32", flag: "\ud83c\udde7\ud83c\uddea" },
  { code: "BZ", name: "Belize", dial: "+501", flag: "\ud83c\udde7\ud83c\uddff" },
  { code: "BJ", name: "Benin", dial: "+229", flag: "\ud83c\udde7\ud83c\uddef" },
  { code: "BT", name: "Bhutan", dial: "+975", flag: "\ud83c\udde7\ud83c\uddf9" },
  { code: "BO", name: "Bolivia", dial: "+591", flag: "\ud83c\udde7\ud83c\uddf4" },
  { code: "BA", name: "Bosnia and Herzegovina", dial: "+387", flag: "\ud83c\udde7\ud83c\udde6" },
  { code: "BW", name: "Botswana", dial: "+267", flag: "\ud83c\udde7\ud83c\uddfc" },
  { code: "BR", name: "Brazil", dial: "+55", flag: "\ud83c\udde7\ud83c\uddf7" },
  { code: "BN", name: "Brunei", dial: "+673", flag: "\ud83c\udde7\ud83c\uddf3" },
  { code: "BG", name: "Bulgaria", dial: "+359", flag: "\ud83c\udde7\ud83c\uddec" },
  { code: "KH", name: "Cambodia", dial: "+855", flag: "\ud83c\uddf0\ud83c\udded" },
  { code: "CM", name: "Cameroon", dial: "+237", flag: "\ud83c\udde8\ud83c\uddf2" },
  { code: "CA", name: "Canada", dial: "+1", flag: "\ud83c\udde8\ud83c\udde6" },
  { code: "CL", name: "Chile", dial: "+56", flag: "\ud83c\udde8\ud83c\uddf1" },
  { code: "CN", name: "China", dial: "+86", flag: "\ud83c\udde8\ud83c\uddf3" },
  { code: "CO", name: "Colombia", dial: "+57", flag: "\ud83c\udde8\ud83c\uddf4" },
  { code: "CR", name: "Costa Rica", dial: "+506", flag: "\ud83c\udde8\ud83c\uddf7" },
  { code: "HR", name: "Croatia", dial: "+385", flag: "\ud83c\udded\ud83c\uddf7" },
  { code: "CU", name: "Cuba", dial: "+53", flag: "\ud83c\udde8\ud83c\uddfa" },
  { code: "CY", name: "Cyprus", dial: "+357", flag: "\ud83c\udde8\ud83c\uddfe" },
  { code: "CZ", name: "Czech Republic", dial: "+420", flag: "\ud83c\udde8\ud83c\uddff" },
  { code: "DK", name: "Denmark", dial: "+45", flag: "\ud83c\udde9\ud83c\uddf0" },
  { code: "DO", name: "Dominican Republic", dial: "+1", flag: "\ud83c\udde9\ud83c\uddf4" },
  { code: "EC", name: "Ecuador", dial: "+593", flag: "\ud83c\uddea\ud83c\udde8" },
  { code: "EG", name: "Egypt", dial: "+20", flag: "\ud83c\uddea\ud83c\uddec" },
  { code: "SV", name: "El Salvador", dial: "+503", flag: "\ud83c\uddf8\ud83c\uddfb" },
  { code: "EE", name: "Estonia", dial: "+372", flag: "\ud83c\uddea\ud83c\uddea" },
  { code: "ET", name: "Ethiopia", dial: "+251", flag: "\ud83c\uddea\ud83c\uddf9" },
  { code: "FI", name: "Finland", dial: "+358", flag: "\ud83c\uddeb\ud83c\uddee" },
  { code: "FR", name: "France", dial: "+33", flag: "\ud83c\uddeb\ud83c\uddf7" },
  { code: "GE", name: "Georgia", dial: "+995", flag: "\ud83c\uddec\ud83c\uddea" },
  { code: "DE", name: "Germany", dial: "+49", flag: "\ud83c\udde9\ud83c\uddea" },
  { code: "GH", name: "Ghana", dial: "+233", flag: "\ud83c\uddec\ud83c\udded" },
  { code: "GR", name: "Greece", dial: "+30", flag: "\ud83c\uddec\ud83c\uddf7" },
  { code: "GT", name: "Guatemala", dial: "+502", flag: "\ud83c\uddec\ud83c\uddf9" },
  { code: "HN", name: "Honduras", dial: "+504", flag: "\ud83c\udded\ud83c\uddf3" },
  { code: "HK", name: "Hong Kong", dial: "+852", flag: "\ud83c\udded\ud83c\uddf0" },
  { code: "HU", name: "Hungary", dial: "+36", flag: "\ud83c\udded\ud83c\uddfa" },
  { code: "IS", name: "Iceland", dial: "+354", flag: "\ud83c\uddee\ud83c\uddf8" },
  { code: "IN", name: "India", dial: "+91", flag: "\ud83c\uddee\ud83c\uddf3" },
  { code: "ID", name: "Indonesia", dial: "+62", flag: "\ud83c\uddee\ud83c\udde9" },
  { code: "IR", name: "Iran", dial: "+98", flag: "\ud83c\uddee\ud83c\uddf7" },
  { code: "IQ", name: "Iraq", dial: "+964", flag: "\ud83c\uddee\ud83c\uddf6" },
  { code: "IE", name: "Ireland", dial: "+353", flag: "\ud83c\uddee\ud83c\uddea" },
  { code: "IL", name: "Israel", dial: "+972", flag: "\ud83c\uddee\ud83c\uddf1" },
  { code: "IT", name: "Italy", dial: "+39", flag: "\ud83c\uddee\ud83c\uddf9" },
  { code: "JM", name: "Jamaica", dial: "+1", flag: "\ud83c\uddef\ud83c\uddf2" },
  { code: "JP", name: "Japan", dial: "+81", flag: "\ud83c\uddef\ud83c\uddf5" },
  { code: "JO", name: "Jordan", dial: "+962", flag: "\ud83c\uddef\ud83c\uddf4" },
  { code: "KZ", name: "Kazakhstan", dial: "+7", flag: "\ud83c\uddf0\ud83c\uddff" },
  { code: "KE", name: "Kenya", dial: "+254", flag: "\ud83c\uddf0\ud83c\uddea" },
  { code: "KR", name: "South Korea", dial: "+82", flag: "\ud83c\uddf0\ud83c\uddf7" },
  { code: "KW", name: "Kuwait", dial: "+965", flag: "\ud83c\uddf0\ud83c\uddfc" },
  { code: "LV", name: "Latvia", dial: "+371", flag: "\ud83c\uddf1\ud83c\uddfb" },
  { code: "LB", name: "Lebanon", dial: "+961", flag: "\ud83c\uddf1\ud83c\udde7" },
  { code: "LT", name: "Lithuania", dial: "+370", flag: "\ud83c\uddf1\ud83c\uddf9" },
  { code: "LU", name: "Luxembourg", dial: "+352", flag: "\ud83c\uddf1\ud83c\uddfa" },
  { code: "MY", name: "Malaysia", dial: "+60", flag: "\ud83c\uddf2\ud83c\uddfe" },
  { code: "MV", name: "Maldives", dial: "+960", flag: "\ud83c\uddf2\ud83c\uddfb" },
  { code: "MT", name: "Malta", dial: "+356", flag: "\ud83c\uddf2\ud83c\uddf9" },
  { code: "MX", name: "Mexico", dial: "+52", flag: "\ud83c\uddf2\ud83c\uddfd" },
  { code: "MA", name: "Morocco", dial: "+212", flag: "\ud83c\uddf2\ud83c\udde6" },
  { code: "MZ", name: "Mozambique", dial: "+258", flag: "\ud83c\uddf2\ud83c\uddff" },
  { code: "MM", name: "Myanmar", dial: "+95", flag: "\ud83c\uddf2\ud83c\uddf2" },
  { code: "NP", name: "Nepal", dial: "+977", flag: "\ud83c\uddf3\ud83c\uddf5" },
  { code: "NL", name: "Netherlands", dial: "+31", flag: "\ud83c\uddf3\ud83c\uddf1" },
  { code: "NZ", name: "New Zealand", dial: "+64", flag: "\ud83c\uddf3\ud83c\uddff" },
  { code: "NG", name: "Nigeria", dial: "+234", flag: "\ud83c\uddf3\ud83c\uddec" },
  { code: "NO", name: "Norway", dial: "+47", flag: "\ud83c\uddf3\ud83c\uddf4" },
  { code: "OM", name: "Oman", dial: "+968", flag: "\ud83c\uddf4\ud83c\uddf2" },
  { code: "PK", name: "Pakistan", dial: "+92", flag: "\ud83c\uddf5\ud83c\uddf0" },
  { code: "PA", name: "Panama", dial: "+507", flag: "\ud83c\uddf5\ud83c\udde6" },
  { code: "PY", name: "Paraguay", dial: "+595", flag: "\ud83c\uddf5\ud83c\uddfe" },
  { code: "PE", name: "Peru", dial: "+51", flag: "\ud83c\uddf5\ud83c\uddea" },
  { code: "PH", name: "Philippines", dial: "+63", flag: "\ud83c\uddf5\ud83c\udded" },
  { code: "PL", name: "Poland", dial: "+48", flag: "\ud83c\uddf5\ud83c\uddf1" },
  { code: "PT", name: "Portugal", dial: "+351", flag: "\ud83c\uddf5\ud83c\uddf9" },
  { code: "QA", name: "Qatar", dial: "+974", flag: "\ud83c\uddf6\ud83c\udde6" },
  { code: "RO", name: "Romania", dial: "+40", flag: "\ud83c\uddf7\ud83c\uddf4" },
  { code: "RU", name: "Russia", dial: "+7", flag: "\ud83c\uddf7\ud83c\uddfa" },
  { code: "SA", name: "Saudi Arabia", dial: "+966", flag: "\ud83c\uddf8\ud83c\udde6" },
  { code: "SN", name: "Senegal", dial: "+221", flag: "\ud83c\uddf8\ud83c\uddf3" },
  { code: "RS", name: "Serbia", dial: "+381", flag: "\ud83c\uddf7\ud83c\uddf8" },
  { code: "SG", name: "Singapore", dial: "+65", flag: "\ud83c\uddf8\ud83c\uddec" },
  { code: "SK", name: "Slovakia", dial: "+421", flag: "\ud83c\uddf8\ud83c\uddf0" },
  { code: "SI", name: "Slovenia", dial: "+386", flag: "\ud83c\uddf8\ud83c\uddee" },
  { code: "ZA", name: "South Africa", dial: "+27", flag: "\ud83c\uddff\ud83c\udde6" },
  { code: "ES", name: "Spain", dial: "+34", flag: "\ud83c\uddea\ud83c\uddf8" },
  { code: "LK", name: "Sri Lanka", dial: "+94", flag: "\ud83c\uddf1\ud83c\uddf0" },
  { code: "SE", name: "Sweden", dial: "+46", flag: "\ud83c\uddf8\ud83c\uddea" },
  { code: "CH", name: "Switzerland", dial: "+41", flag: "\ud83c\udde8\ud83c\udded" },
  { code: "TW", name: "Taiwan", dial: "+886", flag: "\ud83c\uddf9\ud83c\uddfc" },
  { code: "TZ", name: "Tanzania", dial: "+255", flag: "\ud83c\uddf9\ud83c\uddff" },
  { code: "TH", name: "Thailand", dial: "+66", flag: "\ud83c\uddf9\ud83c\udded" },
  { code: "TR", name: "Turkey", dial: "+90", flag: "\ud83c\uddf9\ud83c\uddf7" },
  { code: "UA", name: "Ukraine", dial: "+380", flag: "\ud83c\uddfa\ud83c\udde6" },
  { code: "AE", name: "United Arab Emirates", dial: "+971", flag: "\ud83c\udde6\ud83c\uddea" },
  { code: "GB", name: "United Kingdom", dial: "+44", flag: "\ud83c\uddec\ud83c\udde7" },
  { code: "US", name: "United States", dial: "+1", flag: "\ud83c\uddfa\ud83c\uddf8" },
  { code: "UY", name: "Uruguay", dial: "+598", flag: "\ud83c\uddfa\ud83c\uddfe" },
  { code: "UZ", name: "Uzbekistan", dial: "+998", flag: "\ud83c\uddfa\ud83c\uddff" },
  { code: "VE", name: "Venezuela", dial: "+58", flag: "\ud83c\uddfb\ud83c\uddea" },
  { code: "VN", name: "Vietnam", dial: "+84", flag: "\ud83c\uddfb\ud83c\uddf3" },
  { code: "ZM", name: "Zambia", dial: "+260", flag: "\ud83c\uddff\ud83c\uddf2" },
  { code: "ZW", name: "Zimbabwe", dial: "+263", flag: "\ud83c\uddff\ud83c\uddfc" },
];

export default countries;
